import React from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import * as AppRoutes from '@/modules/routes';
import DevDashboard from '../DevView/DevDashboard';
import type { DevTool } from '../DevView/DevDashboard';
import { UserSearchRoutes } from './UserSearch/UserSearchRoutes';

export interface SupportViewProps {
  supportPath: string;
}

/* eslint-disable max-len */
const supportTools = (supportPath: string): DevTool[] => [
  { description: 'Find any user or order across all subscribers.', href: '/sysadmin/support/user-search', routerPath: '/support/user-search', title: 'User Search' },
  { description: 'Subscriber accounts, licenses, and settings.', href: supportPath, title: 'Subscribers' },
  { description: 'Search teachers across subscribers.', href: AppRoutes.admin_search_index_path(), title: 'Teachers' },
  { description: 'Search purchase orders.', href: AppRoutes.search_admin_search_purchase_orders_path(), title: 'Purchase Orders' },
  { description: 'Search staffer invitations.', href: AppRoutes.search_admin_invitations_path(), title: 'Invitations' },
  { description: 'System-wide messages.', href: AppRoutes.admin_system_messages_path(), title: 'Sys Messages' },
];
/* eslint-enable max-len */

// AIDEV-NOTE: Support view — User Search is the first SPA page here; the rest of the legacy
// Support header still opens full-reload pages, listed on the launcher and in the rail.
const SupportView = ({ supportPath }: SupportViewProps) => {
  const navigate = useNavigate();

  return (
    <Routes>
      <Route
        element={(
          <DevDashboard
            description="Tools for looking after subscribers and their users."
            title="Support"
            tools={supportTools(supportPath)}
            onNavigate={navigate}
          />
        )}
        path="/"
      />
      <Route element={<UserSearchRoutes layout="rail" />} path="/user-search/*" />
    </Routes>
  );
};

export default SupportView;
